import React from 'react'
import { Oval } from 'react-loader-spinner'
import styled from 'styled-components'

function PageLoader() {
  return (
    <LoaderView>
      <Oval color="#92C22C" width={50} height={50} strokeWidth={5} />
    </LoaderView>
  )
}

export default PageLoader

const LoaderView = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors?.white};
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30000;
`
